import React from "react";

const Textarea = React.forwardRef(
  ({ className = "", rows = 4, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={`w-full px-3 py-2 rounded-md border border-gray-300 
          focus:outline-none focus:ring-2 focus:ring-black 
          disabled:opacity-50 resize-none ${className}`}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export default Textarea;
